// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__3P2X-","wrap":"Layout_wrap__1v3WG","content":"Layout_content__3d6aH"};